import React, { useCallback, useRef, useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import styled, { css } from 'styled-components';
import MathContent from '../../../math-content';
import { Container, Value } from '..';

export const SelectedContainer = styled(Container)`
    ${(props) =>
        !props.disabled &&
        css`
            border: 1px solid var(--blue400);
            box-shadow: var(--shadow-2);
            background-color: var(--blue50);
            text-align: center;

            &:focus {
                box-shadow: var(--outline);
            }

            &:hover {
                border: 1px solid var(--blue700);
                color: var(--blue700);
                box-shadow: var(--shadow-2);
            }

            &:active {
                background-color: var(--blue50);
                border: 1px solid var(--blue400);
                box-shadow: var(--shadow-4);
                outline: none;
            }
        `}
`;

const ChoiceChipSelected = ({ disabled = false, id, handleClick, value, scrollingFn }) => {
    const ref = useRef(null);
    const [mathRendered, setMathRendered] = useState(false);
    useEffect(() => {
        scrollingFn && scrollingFn(ref, mathRendered);
        return () => {};
    }, [scrollingFn, mathRendered]);

    const onClick = () => {
        if (!disabled && handleClick) {
            handleClick();
        }
    };

    const onRendered = useCallback(() => setMathRendered(true), []);

    return (
        <SelectedContainer aria-pressed="false" disabled={disabled} id={id} role="button" tabIndex="0" onClick={onClick}>
            <Value ref={ref} onScroll={() => scrollingFn(ref)}>
                <MathContent onRendered={onRendered} inTabOrder={false}>
                    {value}
                </MathContent>
            </Value>
        </SelectedContainer>
    );
};

ChoiceChipSelected.propTypes = {
    disabled: PropTypes.bool,
    id: PropTypes.string,
    handleClick: PropTypes.func,
    value: PropTypes.string,
    scrollingFn: PropTypes.func,
};

export default ChoiceChipSelected;
